module.exports = __webpack_public_path__ + "static/home-3fe5f53d6b0efea2c84bc873a17baa3a.jpg";